module.exports = __webpack_public_path__ + "static/img/tooltip-solar-panel-body.128fb51.png";